var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4CeeLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2625,
    height: 907,
    viewBox: "0 0 2625 907",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 802,
    width: 2625,
    height: 907
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 580.666,
    y1: 876.294,
    x2: 1499.33,
    y2: 1634.71,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect",
    id: "fill1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6A3FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#603DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4A3AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3B38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3237BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3037BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7FFB"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-279 -802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1248 1255.5C1248 1341.93 1178.15 1412 1092 1412 1005.85 1412 936 1341.93 936 1255.5 936 1169.07 1005.85 1099 1092 1099 1178.15 1099 1248 1169.07 1248 1255.5",
    fill: "#6E7FFB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 1255.5C395 1287.26 369.032 1313 337 1313 304.968 1313 279 1287.26 279 1255.5 279 1223.74 304.968 1198 337 1198 369.032 1198 395 1223.74 395 1255.5",
    fill: "#6E7FFB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1453 1255.5C1453 1292.22 1422.99 1322 1386 1322 1349.01 1322 1319 1292.22 1319 1255.5 1319 1218.79 1348.98 1189 1386 1189 1423.02 1189 1453 1218.79 1453 1255.5",
    fill: "#6E7FFB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.5 1147C509.592 1147 461 1195.56 461 1255.5 461 1315.44 509.561 1364 569.5 1364 629.439 1364 678 1315.44 678 1255.5 678 1195.56 629.439 1147 569.5 1147",
    fill: "#6E7FFB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.64 1465.78C1338.53 1459.52 1321.1 1456.33 1300.88 1456.33 1275.01 1456.33 1251.59 1463.37 1231.15 1477.25 1209.5 1491.78 1185.87 1503.55 1160.84 1512.2 1135.56 1520.87 1108.27 1525.27 1079.73 1525.27 1042.85 1525.27 1007.46 1518.18 974.525 1504.17 941.679 1490.23 912.43 1470.77 887.524 1446.36 862.618 1421.94 842.613 1393.07 828.004 1360.5 813.303 1327.78 805.828 1292.43 805.828 1255.5 805.828 1218.57 813.271 1183.22 827.973 1150.5 842.582 1117.97 862.618 1089.18 887.524 1064.92 912.399 1040.73 941.648 1021.3 974.401 1007.17 991.15 999.92 1008.55 994.467 1026.2 990.966L1031.28 990.005C1047.07 987.186 1063.36 985.73 1079.67 985.73 1107.83 985.73 1134.88 990.005 1160.09 998.464 1184.91 1006.83 1208.82 1018.7 1231.21 1033.82 1252 1048.07 1275.41 1055.29 1300.85 1055.29 1319.8 1055.29 1336.98 1051.88 1351.93 1045.19 1367.07 1038.4 1380.65 1029.08 1392.28 1017.46L1437.94 971.819C1414.55 947.869 1389.65 925.746 1363.81 906.01 1335 884.043 1304.72 865.175 1273.8 849.838 1243.22 834.625 1211.05 822.697 1178.21 814.393 1145.7 806.183 1112.55 802 1079.67 802 1037.89 802 997.104 807.422 958.396 818.142 919.626 828.862 882.779 844.23 848.878 863.811 814.946 883.424 783.775 907.281 756.202 934.701 728.629 961.966 704.56 992.763 684.709 1026.29 666.937 1056.28 652.608 1088.59 642 1122.55 688.99 1148.36 720.937 1198.27 720.937 1255.53 720.937 1312.79 689.021 1362.7 642.031 1388.51 652.669 1422.44 666.999 1454.75 684.74 1484.68 704.56 1518.14 728.629 1549 756.264 1576.36 783.868 1603.75 815.039 1627.58 848.94 1647.19 882.841 1666.83 919.688 1682.17 958.458 1692.86 997.167 1703.58 1037.95 1709 1079.73 1709 1112.61 1709 1145.77 1704.85 1178.27 1696.61 1210.87 1688.37 1243.03 1676.44 1273.89 1661.16 1304.79 1645.86 1335.06 1626.96 1363.87 1605.02 1389.74 1585.25 1414.61 1563.16 1438 1539.18L1392.34 1493.54C1380.34 1481.55 1366.97 1472.2 1352.67 1465.75",
    fill: "url(#fill1)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2904 1427.79 2904 1339.57 2717.47 1339.57 2717.47 1284.11 2871.24 1284.11 2871.24 1199.59 2717.47 1199.59 2717.47 1142.54 2904 1142.54 2904 1053.8 2621.84 1053.8 2621.84 1427.85 2904 1427.85ZM2573.83 1427.79 2573.83 1339.57 2387.31 1339.57 2387.31 1284.11 2541.08 1284.11 2541.08 1199.59 2387.31 1199.59 2387.31 1142.54 2573.83 1142.54 2573.83 1053.8 2291.67 1053.8 2291.67 1427.85 2573.83 1427.85ZM2163.84 1416.17C2188.66 1405.6 2209.18 1389.68 2225.38 1368.36 2241.59 1347.04 2250.73 1320.55 2252.87 1288.85L2160.4 1288.85C2157.92 1300.13 2153.43 1309.74 2146.92 1317.64 2140.41 1325.57 2132.2 1331.55 2122.34 1335.61 2112.49 1339.67 2100.87 1341.68 2087.48 1341.68 2065.29 1341.68 2047.6 1336.47 2034.39 1326.09 2021.19 1315.72 2011.68 1302.58 2005.85 1286.74 2000.03 1270.91 1997.14 1254.86 1997.14 1238.69 1997.14 1222.51 1999.87 1206.8 2005.33 1191.65 2010.78 1176.5 2020.05 1164.01 2033.06 1154.13 2046.08 1144.28 2063.71 1139.35 2085.9 1139.35 2106.69 1139.35 2122.87 1144.03 2134.52 1153.36 2146.14 1162.68 2154.08 1175.82 2158.29 1192.71L2248.66 1192.71C2245.84 1160.3 2236.85 1133.53 2221.7 1112.39 2206.54 1091.26 2186.9 1075.43 2162.79 1064.83 2138.64 1054.27 2111.96 1049 2082.74 1049 2045.74 1049 2013.41 1056.84 1985.77 1072.52 1958.13 1088.2 1936.62 1110.57 1921.31 1139.6 1905.97 1168.66 1898.32 1203.09 1898.32 1242.87 1898.32 1282.65 1905.72 1315.16 1920.51 1343.51 1935.29 1371.86 1956.61 1393.7 1984.44 1409.01 2012.27 1424.32 2045.55 1432 2084.32 1432 2112.49 1432 2139.02 1426.7 2163.84 1416.14M1730.23 1164.7 1730.23 1276.18 1656.26 1276.18 1730.23 1164.7ZM1824.81 1427.79 1824.81 1362.81 1866.03 1362.81 1866.03 1276.18 1824.81 1276.18 1824.81 1053.77 1716.5 1053.77 1549 1289.91 1549 1362.81 1730.23 1362.81 1730.23 1427.79 1824.81 1427.79Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4CeeLogoWhite);
export default __webpack_public_path__ + "static/media/4cee-logo-white.701b1f78f72d221fe41dae8a7ac8fd6e.svg";
export { ForwardRef as ReactComponent };